import React, { useState, useEffect } from "react";
import Paper from "@mui/material/Paper";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@emotion/react";
import Spinner from "../../../components/Spinner";
import { getFaqList } from "../../../http/auth";
import FaqTable from "./FaQTable";


export default function ManageFaqs() {
  const theme = useTheme();
  const smScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [page, setPage] = useState(1);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0)
  const [nextId, setNextId] = useState("");

  const columns = [
    { id: "sr", label: "Sl. No.", minWidth: 40 },
    { id: "title", label: "Question", minWidth: 140, sortable: true },
    { id: "action", label: "Action", minWidth: 60 },
  ];


  useEffect(() => {
    getFaqs()
  }, [])

  const getFaqs = async (pageArg) => {
    try {
      setLoading(true)
      const pg = pageArg ? pageArg : page
      const res = await getFaqList(pg)
      const faqs = res?.data?.data?.faq
      if (faqs) updateRows(faqs, pg)
      setTotalCount(res.data?.data?.totalFAQ)
      setLoading(false)
    } catch (err) {
      setLoading(false)
      // dispatch(showToast({ color: "error", msg: "Something went wrong" }));
    }
  }


  function createData(sr, question, answer, id, action) {
    return { sr, question, answer, id, action };
  }

  const updateRows = (faqs, pageArg) => {
    const list = faqs.map((item, index) => {
      return createData(
        ((pageArg - 1) * 10 + 1) + index + 1,
        item.question || "",
        item.answer,
        item._id,
        "-",
      );
    });
    const updatedList = nextId ? [...rows, ...list] : list;
    setRows(updatedList);
  };

  const onNextClick = async () => {
    setPage(page + 1);
    getFaqs(page + 1)
  };

  const onPrevClick = async () => {
    setPage(page - 1);
    getFaqs(page - 1)
  };

  return (
    <Paper
      sx={{
        width: "100%",
        height: "100%",
        overflow: "hidden",
        boxSizing: "border-box",
        boxShadow: "none",
      }}
    >
      <>
        {!loading ? (
          <FaqTable
            smScreen={smScreen}
            columns={columns}
            rows={rows}
            page={page}
            setPage={setPage}
            nextId={nextId}
            rowsPerPage={10}
            setLoading={setLoading}
            onPrevClick={onPrevClick}
            onNextClick={onNextClick}
            totalCount={totalCount}
            getFaqs={getFaqs}
          />
        ) : (
          <Spinner />
        )}
      </>
    </Paper>
  );
}

